/**
 * 侧栏宽度。
 *
 * 存在 localStorage：拖一次就该记住，这是「看的方式」而不是「看的东西」——
 * 跟侧栏在哪一页同理，不进地址栏（不然分享出去的链接会把你的宽度强加给别人）。
 */

export const SIDE_MIN = 200;
export const SIDE_MAX = 480;
export const SIDE_DEFAULT = 246;

/** 右边至少留这么宽。窄屏上不设这条，侧栏能把内容区挤到没有。 */
const CONTENT_MIN = 360;

const KEY = 'capsio.sideWidth';

/**
 * 夹在合法范围里。
 *
 * 上限取「设定上限」和「视口减去内容区最小宽」里更小的那个：
 * 1000px 宽的窗口上，480 的侧栏会只剩 520 给内容，能用但已经很挤；
 * 600px 的窗口上，那就是把内容挤没了。所以视口这条是硬约束。
 *
 * 视口本身就比 min + CONTENT_MIN 还窄时（很小的窗口），让下限赢——
 * 侧栏窄到看不了字不如干脆收起来，那是另一个按钮的事。
 */
export function clampSideWidth(px: number, viewportWidth: number): number {
  const roomBased = viewportWidth - CONTENT_MIN;
  const max = Math.max(SIDE_MIN, Math.min(SIDE_MAX, roomBased));
  return Math.round(Math.min(max, Math.max(SIDE_MIN, px)));
}

export function readSideWidth(viewportWidth: number): number {
  try {
    const raw = window.localStorage.getItem(KEY);
    if (raw === null) return SIDE_DEFAULT;
    const px = Number(raw);
    // 存的是坏值（手改过、或者换了版本）就退回默认，不要把 NaN 传下去
    return Number.isFinite(px) ? clampSideWidth(px, viewportWidth) : SIDE_DEFAULT;
  } catch {
    // 隐私模式下 localStorage 会抛，宽度不值得为它挡住整个界面
    return SIDE_DEFAULT;
  }
}

export function storeSideWidth(px: number): void {
  try {
    window.localStorage.setItem(KEY, String(px));
  } catch {
    // 存不上就算了，下次进来用默认宽度
  }
}
